import {
    formFieldsPlaygroundFields as fields,
    paymentKindOptions,
} from "./formFieldsPlayground.schema";
import { StateRow, TIP } from "./FormFieldsPlaygroundStateRow";

/** Every kit field in its normal, optional, tip, error and disabled states. */
export const FormFieldsPlaygroundRows = () => (
    <>
        <StateRow
            title="fields.Text"
            cells={{
                normal: <fields.Text name="text.normal" label="Payee" />,
                optional: (
                    <fields.Text
                        name="text.optional"
                        label="Nickname"
                        optional
                    />
                ),
                tip: (
                    <fields.Text
                        name="text.tip"
                        label="Reference"
                        placeholder="e.g. 1042"
                        description={TIP}
                    />
                ),
                error: <fields.Text name="text.error" label="Billing email" />,
                disabled: (
                    <fields.Text name="text.disabled" label="Payee" disabled />
                ),
            }}
        />
        <StateRow
            title="fields.TextArea"
            cells={{
                normal: (
                    <fields.TextArea
                        name="textArea.normal"
                        label="Memo"
                        autoGrow
                    />
                ),
                optional: (
                    <fields.TextArea
                        name="textArea.optional"
                        label="Note"
                        optional
                        autoGrow
                    />
                ),
                tip: (
                    <fields.TextArea
                        name="textArea.tip"
                        label="Memo"
                        description={TIP}
                        autoGrow
                    />
                ),
                error: (
                    <fields.TextArea
                        name="textArea.error"
                        label="Memo"
                        autoGrow
                    />
                ),
                disabled: (
                    <fields.TextArea
                        name="textArea.disabled"
                        label="Memo"
                        disabled
                        autoGrow
                    />
                ),
            }}
        />
        <StateRow
            title="fields.Date"
            cells={{
                normal: <fields.Date name="date.normal" label="Check date" />,
                optional: (
                    <fields.Date
                        name="date.optional"
                        label="Due date"
                        optional
                        clearable
                        emptyValue={undefined}
                    />
                ),
                tip: (
                    <fields.Date
                        name="date.tip"
                        label="Cleared on"
                        description="Clears to null"
                        clearable
                        emptyValue={null}
                    />
                ),
                error: <fields.Date name="date.error" label="Start date" />,
                disabled: (
                    <fields.Date
                        name="date.disabled"
                        label="Posted on"
                        disabled
                    />
                ),
            }}
        />
        <StateRow
            title="fields.DateRange"
            cells={{
                normal: (
                    <fields.DateRange name="dateRange.normal" label="Period" />
                ),
                optional: (
                    <fields.DateRange
                        name="dateRange.optional"
                        label="Compare to"
                        optional
                        clearable
                        emptyValue={undefined}
                    />
                ),
                tip: (
                    <fields.DateRange
                        name="dateRange.tip"
                        label="Closed period"
                        description="All time clears to null"
                        clearable
                        emptyValue={null}
                    />
                ),
                error: (
                    <fields.DateRange
                        name="dateRange.error"
                        label="Budget period"
                    />
                ),
                disabled: (
                    <fields.DateRange
                        name="dateRange.disabled"
                        label="Locked period"
                        disabled
                    />
                ),
            }}
        />
        <StateRow
            title="fields.Money"
            cells={{
                normal: (
                    <fields.Money
                        name="money.normal"
                        label="Check amount"
                        allowNegative={false}
                    />
                ),
                optional: (
                    <fields.Money
                        name="money.optional"
                        label="Fee"
                        optional
                        clearable
                        emptyValue={undefined}
                    />
                ),
                tip: (
                    <fields.Money
                        name="money.tip"
                        label="Refund"
                        description="Clears to null"
                        clearable
                        emptyValue={null}
                    />
                ),
                error: <fields.Money name="money.error" label="Deposit" />,
                disabled: (
                    <fields.Money
                        name="money.disabled"
                        label="Opening balance"
                        disabled
                    />
                ),
            }}
        />
        <StateRow
            title="fields.Count"
            cells={{
                normal: (
                    <fields.Count
                        name="count.normal"
                        label="Repeat every"
                        min={1}
                    />
                ),
                optional: (
                    <fields.Count
                        name="count.optional"
                        label="Occurrences"
                        optional
                        min={1}
                    />
                ),
                tip: (
                    <fields.Count
                        name="count.tip"
                        label="Copies"
                        description={TIP}
                        min={1}
                    />
                ),
                error: <fields.Count name="count.error" label="Occurrences" />,
                disabled: (
                    <fields.Count
                        name="count.disabled"
                        label="Months"
                        disabled
                    />
                ),
            }}
        />
        <StateRow
            title="fields.Select"
            cells={{
                normal: (
                    <fields.Select
                        name="select.normal"
                        label="Type"
                        options={paymentKindOptions}
                    />
                ),
                optional: (
                    <fields.Select
                        name="select.optional"
                        label="Type"
                        optional
                        placeholder="Select type"
                        options={paymentKindOptions}
                    />
                ),
                tip: (
                    <fields.Select
                        name="select.tip"
                        label="Type"
                        description={TIP}
                        options={paymentKindOptions}
                    />
                ),
                error: (
                    <fields.Select
                        name="select.error"
                        label="Type"
                        options={paymentKindOptions}
                    />
                ),
                disabled: (
                    <fields.Select
                        name="select.disabled"
                        label="Type"
                        disabled
                        options={paymentKindOptions}
                    />
                ),
            }}
        />
    </>
);
